<template>
<div class="page-wrapper">
  <section>
    <Select placeholder="项目名称" v-model="projectFid"
            style="width: 300px;" class="mb16"
            @on-change="changeProject"
    >
<!--      <Option value="">请选择</Option>-->
      <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
    </Select>
    <div class="flex mb16">
      <div class="avator">
        <Icon type="person"></Icon>
      </div>
      <div style="font-weight: bold;">
        <div style="font-size:larger;font-weight: bold">{{name}}</div>
        <div v-if="pageData" style="margin-top: 8px">{{pageData.role}} | {{pageData.department}}</div>
      </div>
    </div>
  </section>
  <info class="mb8" :pageData="pageData"></info>
  <section class="flex " style="justify-content: space-between" v-if="false">
    <div class="charts">
      <charts :pageData="pageData" v-if="pageData"></charts>
    </div>
    <div class="condition flexauto">
      <condition ref="condition" :pageData="pageData"
                 @caculate="caculate"
                 @reset="reset"
                 :projectFid="projectFid"
      ></condition>
    </div>
  </section>
</div>
</template>

<script>
  import {getProjects} from "../../../api/common";
  import { mapGetters } from 'vuex';
  import Info from './components/Info'
  import Charts from './components/Charts'
  import Condition from './components/Condition'
  import {kanbandetail} from "../../../api/dashboard";
  import {formatDateTime} from "../../../utils/format";


  export default {
    name: "performanceboard",
    components:{
      Info,
      Charts,
      Condition
    },
    created(){
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data

        if(this.projectList.length){
          this.projectFid=this.projectList[0].value
          let params={
            projectFid:this.projectFid,
            currentDate:formatDateTime(new Date(),false)
          }
          this.kanbandetail(params)

        }
      }).catch(error => {
      })
    },
    computed:{
      ...mapGetters(['name'])
    },
    data(){

      return {
        projectList:[],
        projectFid:'',
        pageData:null
      }
    },
    methods:{
      changeProject(value){
        console.log('changeProject')
        if(!value){
          return
        }
        let params={
          projectFid:value,
          currentDate:formatDateTime(new Date(),false)
          // currentDate:formatDateTime(this.$refs['condition'].date,false)
        }
        this.kanbandetail(params)
        this.$nextTick(()=>{
          // this.$refs['condition'].changeDate()

        })


      },
      reset(){
        console.log('reset')

        let params={
          projectFid:this.projectFid,
          currentDate:formatDateTime(new Date(),false),
          roomDtoList:[]
        }
        this.kanbandetail(params)

      },
      caculate(){
        console.log('caculate')
        console.log(this.$refs['condition'].rommDtoList)
        let params={
          projectFid:this.projectFid,
          currentDate:formatDateTime(this.$refs['condition'].date),
          roomDtoList:this.$refs['condition'].rommDtoList
        }
        this.kanbandetail(params).then(res=>{
          this.$refs['condition'].changeDate()

        })
      },
      kanbandetail(params){
       return kanbandetail(params).then(res=>{
          if(!res.data){
            return
          }
          this.pageData=res.data
        }).catch(error=>{

        })
      }
    }

  }
</script>

<style scoped>
  .charts{
    width: 60%;
    height: 500px;
    /*background-color: rgba(220,220,220,.3);*/
    margin-right: 10px;
  }
  .condition{
    /*height: 480px;*/
    /*border-left: 1px solid rgba(220,220,220,.8);*/
    background-color: rgba(220,220,220,.3);
    padding: 30px 20px 0 20px;
    box-sizing: border-box;

  }
  .avator{
    width: 60px;
    height: 60px;
    margin-right: 15px;
    font-size: 55px;
    line-height: 60px;
    text-align: center;
    color: rgb(210,210,210)

  }

</style>
